import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { useAuthStore } from '../stores/authStores';

const Logout: React.FC = () => {
  const navigate = useNavigate();
  const clearAuth = useAuthStore((state) => state.logout);
  const logoutStarted = useRef(false);

  useEffect(() => {
    if (logoutStarted.current) return;
    logoutStarted.current = true;

    const logout = async () => {
      const token = localStorage.getItem('auth_token');

      try {
        if (token) {
          await axios.post('logout', null, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
        }
      } catch (error) {
        // Sesi lokal tetap harus dibersihkan ketika token sudah kedaluwarsa
        // atau layanan logout sedang tidak dapat dijangkau.
        console.error('Gagal mencabut sesi BRI Life di server', error);
      } finally {
        clearAuth();
        localStorage.removeItem('userData');
        localStorage.removeItem('teleconsultationData');
        localStorage.removeItem('chatMessages');
        localStorage.removeItem('teleconsult_disclaimer');
        sessionStorage.clear();
        navigate('/login', { replace: true });
      }
    };

    logout();
  }, [clearAuth, navigate]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-50 px-6">
      <p className="text-center text-sm text-slate-600">Mengeluarkan akun...</p>
    </main>
  );
};

export default Logout;
